export interface CustomerServiceInfo {
  phone: string;
  hours: string;
}

export const CUSTOMER_SERVICE_INFO: Record<string, CustomerServiceInfo> = {
  GBP: { phone: `+1 800.852.0477`, hours: `M-F 2PM - 1AM GMT | S-S 2PM - 12AM GMT` },
  AUD: { phone: `611-800-727-036`, hours: `M-F 12AM-11AM AEDT | S-S 12AM-10AM AEDT` },
  CAD: { phone: `+1800-935-5475`, hours: `M-F 6AM-5PM PST | S-S 6AM-4PM PST` },
  default: { phone: `800-935-5475`, hours: `M-F 6AM-5PM PST | S-S 6AM-4PM PST` },
};

/** Resolves the customer-service info for a currency, falling back to the default (USD) entry. */
export function getCustomerServiceInfo(currency: string | undefined | null): CustomerServiceInfo {
  return (currency && CUSTOMER_SERVICE_INFO[currency]) || CUSTOMER_SERVICE_INFO['default'];
}
